import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import VueRouter from 'vue-router'
import routes from './routes'
import VueDisqus from 'vue-disqus'
import LoadScript from 'vue-plugin-load-script'
import VueDraggable from 'vuedraggable'
import Ads from 'vue-google-adsense'
import VuePageTitle from 'vue-page-title'

Vue.use(VueRouter);
Vue.use(VueDisqus);
Vue.use(LoadScript);
Vue.use(VueDraggable);
Vue.config.productionTip = false;

// Ads
Vue.use(require('vue-script2'));
Vue.use(Ads.AutoAdsense, { adClient: 'ca-pub-4973050356409524', isNewAdsCode: true });

const router = new VueRouter({mode: 'history', routes});

// Title Plug in
Vue.use(VuePageTitle, {router});

new Vue({
  router,
  render: h => h(App),
}).$mount('#app')

Vue.prototype.window = window